import request from '@/utils/request';

/**
 * @export 保存用户信息
 * @param {*} data
 * @param {planInfo}
 * @returns
 */
export function bindPatient(data, toast) {
	return request({
		url: '/wx/bindPatient',
		method: 'post',
		data: data,
		toast: toast
	});
}

export function updatePatientWx(data, toast) {
	return request({
		url: '/wx/updatePatientWx',
		method: 'put',
		data: data,
		toast: toast
	});
}

/**
 * @export 根据idCard 或者patientId  直接获取用户信息
 * @param {*} params
 */
 export function findBindPatient(params) {
	return request({
		url: '/wx/findBindPatient',
		method: 'get',
		params
	})
}



// WEBPACK FOOTER //
// ./src/api/wxConfig.js